import { createAIHomeStore } from '@edwin/stores'
import { edwinCloudApiClient } from '@services/EdwinCloudApiClient'

export const useAIHomeStore = createAIHomeStore({
  sessionStorage: window.localStorage,
  apiClient: edwinCloudApiClient,
})

export default useAIHomeStore
